module.exports = __webpack_public_path__ + "img/appAsset-flag--BR.44864a2e.svg";